import { createFileRoute } from '@tanstack/react-router'
import { AccountingPage } from '@/features/accounting'

export const Route = createFileRoute('/_authenticated/payouts-view/')({
  component: () => (
    <AccountingPage
      kind='payouts'
      
      mode='view'
      reviewPermission='payout.review'
      pageKey='payoutView'
    />
  ),
})
